import { render, staticRenderFns } from "./ListSnippets.vue?vue&type=template&id=12964cb7"
import script from "./ListSnippets.vue?vue&type=script&lang=js"
export * from "./ListSnippets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports